export default __webpack_public_path__ + "assets/ico_booking_rulebased-ee67ed01.svg";